import { Monitor, Moon, Sun } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip'
import { useTheme } from '@/lib/hooks'

const themeList = ['system', 'dark', 'light']

export const ThemeSwitcher = () => {
  const { theme, setTheme } = useTheme()

  const handleOnClick = () => {
    const currentIndex = themeList.indexOf(theme)
    const nextIndex = (currentIndex + 1) % themeList.length
    setTheme(themeList[nextIndex] as 'system' | 'dark' | 'light')
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="icon" onClick={handleOnClick}>
          {theme === 'system' ? (
            <Monitor className="opacity-60" />
          ) : theme === 'dark' ? (
            <Moon className="opacity-60" />
          ) : (
            <Sun className="opacity-60" />
          )}
          <span className="sr-only">
            {theme === 'system'
              ? 'System theme, switch to dark'
              : theme === 'dark'
                ? 'Dark theme, switch to light'
                : 'Light theme, switch to system'}
          </span>
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        {theme === 'system'
          ? 'System theme'
          : theme === 'dark'
            ? 'Dark theme'
            : 'Light theme'}
      </TooltipContent>
    </Tooltip>
  )
}
